import React from 'react';
import TeamsIcon from '@atlaskit/icon/core/teams';
import MultiGroupPickerField from '@atlassian/jira-issue-create-commons/src/ui/multi-grouppicker-field/index.tsx';
import type { UserPickerOption } from '@atlassian/jira-issue-field-group-picker/src/common/types.tsx';
import { MULTI_GROUP_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { DropdownFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { multipleGroupPickerFieldWriter } from '../writers/index.tsx';

const MultiGroupCustomFieldTypeComponent = (props: ProvidedFieldProps) => (
	<MultiGroupPickerField {...props} />
);

export const MultiGroupCustomFieldTypeConfig: FieldTypeConfig<UserPickerOption[]> = {
	icon: TeamsIcon,
	type: MULTI_GROUP_CF_TYPE,
	Component: MultiGroupCustomFieldTypeComponent,
	placeholder: <DropdownFieldPlaceholder />,
	writer: multipleGroupPickerFieldWriter,
};
